import React, { useState } from "react";
import { Upload, Button, Input, Space, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { api } from "../api";
import { compressImage } from "../utils";

// Uploads to Cloudinary via the backend and reports back the secure URL.
// Also lets the admin paste a URL directly as a fallback.
const ImageUpload = ({ value, onChange }) => {
    const [uploading, setUploading] = useState(false);

    const customRequest = async ({ file, onSuccess, onError }) => {
        setUploading(true);
        try {
            // Shrink large images client-side so they never hit the size limit.
            const compressed = await compressImage(file);
            const { url, publicId } = await api.uploadImage(compressed);
            onChange?.(url, publicId);
            onSuccess?.(url);
            message.success("Image uploaded");
        } catch (err) {
            message.error(err.message || "Upload failed");
            onError?.(err);
        } finally {
            setUploading(false);
        }
    };

    return (
        <Space direction="vertical" style={{ width: "100%" }}>
            {value ? (
                <img
                    src={value}
                    alt="preview"
                    style={{
                        width: "100%",
                        maxHeight: 160,
                        objectFit: "cover",
                        borderRadius: 8,
                        border: "1px solid #eee",
                    }}
                />
            ) : null}
            <Space.Compact style={{ width: "100%" }}>
                <Input
                    placeholder="Image URL (or upload →)"
                    value={value || ""}
                    onChange={(e) => onChange?.(e.target.value)}
                />
                <Upload
                    showUploadList={false}
                    accept="image/*"
                    customRequest={customRequest}
                >
                    <Button icon={<UploadOutlined />} loading={uploading}>
                        Upload
                    </Button>
                </Upload>
            </Space.Compact>
        </Space>
    );
};

export default ImageUpload;
